import { Controller } from "stimulus";

export default class extends Controller {
  leavingPage() {
    $.ajax({
      url: this.element.dataset.unclaimUrl,
      type: "delete",
    });
  }
}
